import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, MapPin, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-obsidian text-white" data-testid="footer">
      <div className="section-padding py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-3xl mb-4">Illuminate</h3>
            <p className="text-neutral-400 text-sm leading-relaxed">
              Where beauty meets elegance. Experience luxury hair & beauty
              services in the heart of Amritsar.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.instagram.com/illuminate_salon/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-neutral-700 flex items-center justify-center hover:border-gold hover:text-gold transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.facebook.com/illuminatesalons/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-neutral-700 flex items-center justify-center hover:border-gold hover:text-gold transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gold mb-6">
              Quick Links
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/services" className="text-neutral-400 hover:text-white transition-colors text-sm">
                Services
              </Link>
              <Link to="/gallery" className="text-neutral-400 hover:text-white transition-colors text-sm">
                Gallery
              </Link>
              <Link to="/reviews" className="text-neutral-400 hover:text-white transition-colors text-sm">
                Reviews
              </Link>
              <Link to="/book" className="text-neutral-400 hover:text-white transition-colors text-sm">
                Book Appointment
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gold mb-6">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex gap-3">
                <Phone size={18} className="text-gold flex-shrink-0 mt-1" />
                <div>
                  <a href="tel:+917837774865" className="text-sm hover:text-gold transition-colors">
                    078377 74865
                  </a>
                </div>
              </div>
              <div className="flex gap-3">
                <MapPin size={18} className="text-gold flex-shrink-0 mt-1" />
                <div>
                  <p className="text-neutral-400 text-sm">
                    18-D, First Floor, near Danik Bhaskar Office,<br />
                    Ranjit Avenue, Amritsar, Punjab 143001
                  </p>
                  <a 
                    href="https://www.google.com/maps/dir//18-D,+First+Floor,+near+Danik+Bhaskar+Office,+Gumtala+Sub+Urban,+Defence+Colony,D-Block,+Ranjit+Avenue,+Amritsar,+Punjab+143001"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gold text-xs hover:underline mt-1 inline-block"
                  >
                    Get Directions →
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gold mb-6">
              Working Hours
            </h4>
            <div className="flex gap-3">
              <Clock size={18} className="text-gold flex-shrink-0 mt-1" />
              <div className="text-sm">
                <p className="text-white">All Days</p>
                <p className="text-neutral-400">10:30 AM - 8:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-neutral-800">
        <div className="section-padding py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-xs">
            © {new Date().getFullYear()} Illuminate Salon. All rights reserved.
          </p>
          <p className="text-neutral-500 text-xs">
            Made with love in Amritsar
          </p>
        </div>
      </div>
    </footer>
  );
}
